import * as React from "react";
import { ShopLotteryView} from "../../components";
import { Socket } from "socket.io-client";
import { SocketContext, socket } from "../../socket";

const ShopOwnerTickets: React.FC<{}> = () => {
    console.log("Shop owner provider - ", socket);
    return (
        <SocketContext.Provider value={socket}>
            <ShopLotteryView />
        </SocketContext.Provider>
    );
};

export default ShopOwnerTickets;
